export default __webpack_public_path__ + "images/665b0649d71d2346897204d8f4ddab22-chicago_desktop.webp";